import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_sidebar/project')({
	component: ProjectLayout,
})

function ProjectLayout() {
	return <Outlet />
}
